import { config as articleReferenceConfig } from '../../../dynamic-content-page/content-components/article-reference';
import { blogConfig as buttonConfig } from '../../../dynamic-content-page/content-components/button';
import { config as downloadConfig } from '../../../dynamic-content-page/content-components/download';
import { config as flexibleContentConfig } from '../../../dynamic-content-page/content-components/flexible-content';
import { config as mediaGalleryConfig } from '../../../dynamic-content-page/content-components/media-gallery';
import { config as quoteConfig } from '../../../dynamic-content-page/content-components/single-quote';
import { config as spacerConfig } from '../../../dynamic-content-page/content-components/spacer';
import { config as videoWithCaptionConfig } from '../../../dynamic-content-page/content-components/video-with-caption';
import {
  GenericConfig,
  getGenericSectionConfig,
} from '../../../dynamic-content-page/fragment-and-types';

export const possibleComponents: GenericConfig[] = [
  getGenericSectionConfig(flexibleContentConfig),
  getGenericSectionConfig(quoteConfig),
  getGenericSectionConfig(downloadConfig),
  getGenericSectionConfig(spacerConfig),
  getGenericSectionConfig(videoWithCaptionConfig),
  getGenericSectionConfig(mediaGalleryConfig),
  getGenericSectionConfig(articleReferenceConfig),
  getGenericSectionConfig(buttonConfig),
];
